<app-loading *ngIf="isSubmitting" loadingSymbol="dots" color="var(--dashboard-primary-color)" size=".7">
</app-loading>